import { SubscriptionResponseDto } from "@api/bi-service";
import { FREE_TIER_TOKEN_LIMIT } from "../constants";

const FREE_PLAN_NAMES = new Set(["free", "free-tier", "free_tier"]);

const normalizePlan = (plan?: string): string | null => {
  if (!plan) return null;

  const normalized = plan.trim().toLowerCase();
  return normalized.length > 0 ? normalized : null;
};

/**
 * Whether the user has anything for the billing portal to show. A never-subscribed user has no
 * customer record upstream, so opening the portal for them just 404s.
 */
export const hasBillingAccount = (subscription: SubscriptionResponseDto | null | undefined): boolean => {
  if (!subscription) return false;
  if (subscription.hasActiveSubscription) return true;

  return typeof subscription.chargebeeCustomerId === "string" && subscription.chargebeeCustomerId.trim().length > 0;
};

export const isPremiumSubscription = (subscription: SubscriptionResponseDto | null | undefined): boolean => {
  if (!subscription?.hasActiveSubscription) return false;

  const normalizedPlan = normalizePlan(subscription.plan);
  if (normalizedPlan) {
    return !FREE_PLAN_NAMES.has(normalizedPlan);
  }

  if (typeof subscription.tokenQuota === "number") {
    return subscription.tokenQuota > FREE_TIER_TOKEN_LIMIT;
  }

  return true;
};
